export default {"src":"/_next/static/media/parking.1123a632.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};